
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"5","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":".923","cy":".923","r":".923","fill":"#939393"}}),_c('circle',{attrs:{"cx":"4","cy":".923","r":".923","fill":"#939393"}}),_c('circle',{attrs:{"cx":".923","cy":"3.999","r":".923","fill":"#939393"}}),_c('circle',{attrs:{"cx":"4","cy":"3.999","r":".923","fill":"#939393"}}),_c('circle',{attrs:{"cx":"4","cy":"7.076","r":".923","fill":"#939393"}}),_c('circle',{attrs:{"cx":".923","cy":"7.076","r":".923","fill":"#939393"}})])
          )
        }
      }
    